import {
  Chart as ChartJS,
  ArcElement,
  Legend,
  Tooltip,
  LinearScale,
  TimeScale,
  CategoryScale,
  PointElement,
  BarElement,
  TimeSeriesScale,
  Decimation,
  LineElement,
  Filler,
} from 'chart.js';
import 'chartjs-adapter-luxon';
import { PeakChart } from 'src/common/components/Graphs/PeakChart';
import zoom from 'chartjs-plugin-zoom';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  TimeScale,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  TimeSeriesScale,
  Decimation,
  LineElement,
  PeakChart,
  zoom,
  Filler,
);

ChartJS.defaults.plugins.tooltip.titleFont = () => ({
  size: 12,
  lineHeight: 1.33,
  weight: '500',
  family: 'Inter Variable',
});
ChartJS.defaults.plugins.tooltip.bodyFont = () => ({
  size: 12,
  lineHeight: 1,
  weight: '400',
});

ChartJS.defaults.plugins.tooltip.backgroundColor = 'rgba(47,50,50, 0.7)';
ChartJS.defaults.plugins.tooltip.boxPadding = 6;
ChartJS.defaults.plugins.tooltip.bodySpacing = 6;

ChartJS.defaults.plugins.tooltip.titleSpacing = 2;
ChartJS.defaults.plugins.tooltip.titleMarginBottom = 2;
